module.exports = __webpack_public_path__ + "img/google-maps_2642502.3f52a77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/franchise/google-maps_2642502.png
// module id = 664
// module chunks = 1